import { IsOptional, IsArray, ValidateNested, ValidateIf, IsDate, IsBoolean } from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "../common";
import { JuniorNumberDto } from "./junior-number.dto";

export class UserUpdateDto {
  @IsOptional()
  display_name?: string;

  @IsOptional()
  phone?: string;

  @IsOptional()
  website?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  address?: AddressDto;

  @IsOptional()
  club_number?: string;

  @IsOptional()
  emergency_contact_name?: string;

  @IsOptional()
  emergency_contact_phone?: string;

  @IsOptional()
  @IsBoolean()
  is_junior?: boolean;

  @IsOptional()
  parent_name?: string;

  @ValidateIf((o) => o.is_junior === true)
  @IsDate({ message: "Invalid date of birth" })
  @Type(() => Date)
  junior_dob?: Date;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => JuniorNumberDto)
  junior_numbers?: JuniorNumberDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => JuniorNumberDto)
  membership_numbers?: JuniorNumberDto[];

  @IsOptional()
  @IsArray()
  favorite_clubs?: string[];

  @IsOptional()
  @IsArray()
  opted_in_clubs?: string[];

  @IsOptional()
  @IsBoolean()
  is_trusted_secretary?: boolean;

  @IsOptional()
  @IsBoolean()
  show_points_reminder?: boolean;
}
